// components/layout/ClientModuleGate.jsx
// A switched-off client menu page sends a Uganda client back to the dashboard
// (the server refuses its routes too). Everyone else passes straight through.
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { clientModuleAPI } from '../../services/api';
import { isUgandaClient } from './clientModules';

export default function ClientModuleGate({ moduleKey, children }) {
  const { user } = useAuth();
  const gated = isUgandaClient(user);
  const [ok, setOk] = useState(gated ? null : true);
  useEffect(() => {
    if (!gated) { setOk(true); return undefined; }
    let live = true;
    clientModuleAPI.mine().then(r => live && setOk(r.modules?.[moduleKey] !== false)).catch(() => live && setOk(true));
    return () => { live = false; };
  }, [gated, moduleKey]);
  if (ok === null) return null;
  return ok ? children : <Navigate to="/dashboard" replace />;
}
